"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUrl = void 0;
const createUrl = (pathname, query, hash) => {
  const url = new URL(pathname, window.location.origin);
  url.search = new URLSearchParams(query).toString();
  url.hash = hash;
  return url;
};
exports.createUrl = createUrl;
